import { useMemo } from 'react';
import { getPaymentAgreements } from '../../../../shared/CIPage/ConsentAndDeclarations/getAgreements';
import { type GiftVoucherState } from '../reducer';

const useGiftVoucherPaymentAgreements = (state: GiftVoucherState) =>
    useMemo(() => getPaymentAgreements(state.giftVoucher.purchaserAgreements), [state.giftVoucher.purchaserAgreements]);

export default useGiftVoucherPaymentAgreements;
